import Vue from 'vue'
import { setValidator } from './validators/validator'
import { loading } from './loading'
import { modal } from './modal'
import { cookie } from './cookie'
import { locale } from './locale'
import { numberToWord } from './numberToWord'
import globalData from './globalData'
import {
  getAssetsUrl,
  customParseFloat,
  click,
  numberFormat,
  priceFormat,
  checkPermissions,
  getReadingTime,
  convertUtcToLocale,
  convertLocaleToUtc,
  convertPersianNumberToEnglish,
  time,
  trim,
  addSpace,
  exportFormat,
  resizeTextOverflow,
  copyToClipboard,
  translateName
} from './other'

const index = {
  getAssetsUrl,
  parseFloat: customParseFloat,
  globalData,
  click,
  loading,
  modal,
  cookie,
  locale,
  numberFormat,
  priceFormat,
  checkPermissions,
  time,
  trim,
  addSpace,
  validator: setValidator,
  numberToWord,
  getReadingTime,
  convertUtcToLocale,
  convertLocaleToUtc,
  convertPersianNumberToEnglish,
  exportFormat,
  resizeTextOverflow,
  copyToClipboard,
  translateName
}

Vue.prototype.$u = index
